<header class="flex justify-between">
	<div class="page-header">
		<h2>Invites</h2>
	</div>

	<atomic-switch
		[matTooltip]="
			restricted
				? 'User can only view their assigned matters'
				: 'User can see all matters'
		"
		label="Restricted Invites"
		[ngModel]="restricted"
		(ngModelChange)="setBusinessRestricted($event)"
	></atomic-switch>
</header>

<div
	class="flex justify-center items-center flex-col"
	*ngIf="!dataSource?.data?.length && !loading"
>
	<img
		class="empty-invite-image"
		src="../../../../assets/images/empty-states/invites.svg"
	/>
	<app-button
		class="mt-10"
		btn="primary"
		[icon]="icon.ADD"
		(onClick)="openInviteDialog()"
		>Invite colleagues</app-button
	>
</div>

<div *ngIf="dataSource?.data?.length && !loading">
	<div class="flex justify-between items-center">
		<app-input
			class="max-w-350 w-full mb-6"
			placeholder="Search for a user"
			[startIcon]="icon.SEARCH"
			(debounce)="applyFilter($event)"
			[(ngModel)]="searchFilter"
		></app-input>
		<app-button btn="primary" [icon]="icon.ADD" (onClick)="openInviteDialog()"
			>Invite colleagues</app-button
		>
	</div>

	<table
		mat-table
		[trackBy]="trackById"
		[dataSource]="dataSource"
		matSort
		class="animate app-table w-full overflow-hidden rounded"
	>
		<ng-container matColumnDef="emailLowercase">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
			<td mat-cell *matCellDef="let element">{{ element.email }}</td>
		</ng-container>

		<ng-container matColumnDef="createdAt">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Sent</th>
			<td mat-cell *matCellDef="let element">
				{{ element.createdAt | date: 'medium' }}
			</td>
		</ng-container>

		<ng-container matColumnDef="inviteLink">
			<th mat-header-cell *matHeaderCellDef></th>
			<td mat-cell *matCellDef="let element">
				<div class="flex flex-nowrap">
					<app-button
						(click)="resendInvite(element.id, element.email)"
						[icon]="icon.RESEND"
						matTooltip="Resend invitation"
						class="mx-3"
					></app-button>
					<app-button
						(click)="deleteInvite(element.id, element.email)"
						[icon]="icon.DELETE"
						matTooltip="Delete invite"
					></app-button>
				</div>
			</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
		<tr
			mat-row
			*matRowDef="let row; columns: displayedColumns"
			class="animate"
		></tr>
		<tr class="mat-row" *matNoDataRow>
			<td
				class="mat-cell"
				[attr.colspan]="displayedColumns.length"
				class="text-center text-grey"
			>
				Sorry, no user invites found. Please try again!
			</td>
		</tr>
	</table>
</div>
